import {
  SESSION_KEY_AUTH_ORIGIN,
  NLB_AUTH_ORIGIN,
  NLB_STG_AUTH_ORIGIN,
} from "src/app/data.client";

/**
 * Checks if the current user is an NLB (National Library Board) user.
 * NLB users are identified by the auth_origin value in sessionStorage.
 *
 * @returns boolean - true if user is an NLB user
 */
export function isNlbUser(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  const authOrigin = sessionStorage.getItem(SESSION_KEY_AUTH_ORIGIN);
  const authOriginLower = authOrigin?.toLowerCase();

  return (
    authOriginLower === NLB_AUTH_ORIGIN ||
    authOriginLower === NLB_STG_AUTH_ORIGIN
  );
}
